import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { CalendarEventDetail } from './types';

import * as dateutil from '@appbase/util/date-helper'

@Component({})
export default class EventListItem extends Vue {
    @Prop({ type: Object }) item!: CalendarEventDetail;
    @Prop({ type: Boolean }) isLoading!: boolean;

    hasColor: boolean = false;
    colorCode: string | null = null;
    className: string = '';
    
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //
    get timeRange() {
        const { isAllDay, startDate, endDate } = this.item;
        if (isAllDay) {
            return this.$t('W_Schedule_Allday').toString();
        } else {
            let start = dateutil.IEDate(startDate);
            let end = dateutil.IEDate(endDate);

            if (start.toDateString() != end.toDateString()) {
                return `${this.convertDate(start)} ~ ${this.convertDate(end)}`;
            } else {
                const slice = (val: any = 0) => ('0' + val).slice(-2);
                const sh = slice(startDate?.getHours());
                const sm = slice(startDate?.getMinutes());
                const eh = slice(endDate?.getHours());
                const em = slice(endDate?.getMinutes());
                return `${sh}:${sm} ~ ${eh}:${em}`;
            }
        }
    }

    convertDate(date: Date) {
        return dateutil.uGetDateFormat("yyyy-MM-DD H:i", date);
    }
}
